import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {enableUniqueIds} from '@cred/shared/unique-id'
import {Field} from 'redux-form'
import emitOnChange from '@cred/react-analytics/hoc/emitOnChange'
import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import withStyles from '@cred/react-theme'

class Radio extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    withBorder: PropTypes.bool,
    radioType: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    showBlockLabel: PropTypes.bool
  }
  static defaultProps = {
    withBorder: false,
    radioType: 'radio',
    showBlockLabel: false
  }

  static displayName = 'Radio'

  constructor(props) {
    super(props)
    enableUniqueIds(this)
  }

  render() {
    const {id, className, withBorder, radioType, styles, ...props} = this.props

    return (
      <div className={[styles[radioType], withBorder ? styles.withBorder : '', className].join(' ')}>
        <Field type="radio" radioType={radioType} component={radioButtonWithAnalytics} id={id || this.nextUniqueId()} styles={styles} {...props}/>
      </div>
    )
  }
}

const radioInput = field => {
    const {styles} = field

    return (
      <div
        ref={field.forwardRef}
        key={field.id}
        tabIndex={-1}
        onKeyPress={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            const {input: {value, onChange}} = field

            onChange(value)
          }
        }}
      >
        <input
          hidden
          type="radio"
          id={field.id}
          disabled={field.disabled}
          {...field.input}
        />

        {field.radioType === 'checkbox' ?
          <label htmlFor={field.id}>
            <span className={styles.checkboxBox}>
              <span className={styles.checkboxIcon}>
                <i className="cred-icon icon-check"/>
              </span>
            </span>
            <span className={[styles.checkboxLabel, 'hidden-xs', 'hidden-sm'].join(' ')}>
              {field.label}
            </span>
            <span className={[styles.checkboxLabel, 'hidden-md', 'hidden-lg', 'hidden-xl'].join(' ')}>
              {field.mobileLabel || field.label}
            </span>
          </label>
         :
          <label htmlFor={field.id} className={field.showBlockLabel ? styles.blockLabel : ''}>
            <span className={styles.radioBox}>
              <span className={styles.radioIcon}/>
            </span>
            <span className={[styles.radioLabel, field.showBlockLabel ? styles.blockLabel : ''].join(' ')}>{field.label}</span>
          </label>
        }
      </div>
    )
  },
  radioButtonWithAnalytics = emitOnChange(radioInput)

export {Radio as RadioNoHoc, radioInput}

export default withStyles(defaultStyles, {fox1})(Radio)
